module.exports = __webpack_public_path__ + "static/media/coinHall.789888e5.png";